import styled, { css } from 'styled-components';

export const Container = styled.div`
    display: flex;
    align-items: center;
    height: 100%;
`;

export const Background = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
`;

export const Wrapper = styled.div`
    ${({ theme }) => css`
        position: relative;
        background: ${theme.colors.accents[10].hex};
        padding-bottom: 1.5rem;
    `}
`;

export const Heading = styled.h2`
    ${({ theme }) => css`
        color: ${theme.colors.primaryContrast.hex};
    `}
`;

export const Text = styled.p`
    ${({ theme }) =>
        css`
            color: ${theme.colors.primaryContrast.hex};
            font-weight: 300;
        `}
`;

export const TabletWaveWrapper = styled.div`
    ${({ theme }) => css`
        position: absolute;
        height: 100%;
        display: none;

        @media ${theme.breakpoints.medium.media} {
            display: block;
            width: 30rem;
            right: 0;
        }

        @media ${theme.breakpoints.large.media} {
            display: none;
            width: 35rem;
            right: unset;
        }
    `}
`;

export const DesktopWaveWrapper = styled.div`
    ${({ theme }) => css`
        display: none;

        @media ${theme.breakpoints.large.media} {
            position: absolute;
            display: block;
            height: 100%;
            width: 32rem;
            right: unset;
            opacity: 0.7;
        }
    `}
`;
